import "./AppFooter.css";
import { APP_CONFIG } from "../../utils/constants.js";

class AppFooter {
  mount(selector) {
    const container = document.querySelector(selector);
    if (!container) {
      throw new Error(`Container not found: ${selector}`);
    }

    container.innerHTML = `
    <footer class="footer">
      <span>Version ${APP_CONFIG.version} • DupScan, un outil de détection automatique des doublons de réflectométrie.</span>
    </footer>
  `;
  }
}

export default AppFooter;
